<template>
  <Modal
    name="team-creation-warning"
    class="team-creation-warning"
    :class="{ 'for-mobile-app': isMobileApp }"
    state="warning"
    :title="title"
    :active="active"
    :noTransition="true"
    @close.prevent="$emit('close')"
  >
    <div class="creation-warning__info">
      <div class="creation-warning__text text-left">
        <ul type="disc">
          <li v-for="(item, index) in info" :key="index">{{ item.text }}</li>
          <li v-if="!info || info.length === 0">Направление: ЗОЖ или спорт (например, беговой клуб);</li>
          <li v-if="!info || info.length === 0">Команда (сообщество) должна состоять из двух и более участников;</li>
        </ul>
      </div>
      <div v-if="showSubtext" class="creation-warning__subtext">
        Если все соответствует, то смело отправляйте заявку на регистрацию команды.
      </div>
    </div>
    <div class="buttons-group">
      <div class="buttons-group__item">
        <Button
          v-if="!isMobileApp"
          variant="primary"
          size="lg"
          text="Продолжить"
          tag="a"
          :href="createLink"
          target="_blank"
          wide
          mobile
        />
        <Button
          v-if="isMobileApp"
          variant="primary"
          size="lg"
          text="Продолжить"
          @click="$emit('create')"
          wide
          mobile
        />
      </div>
      <div class="buttons-group__item buttons-group__item_first">
        <Button
          variant="secondary"
          size="lg"
          text="Отменить"
          @click="$emit('close')"
          wide
          mobile
        />
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'TeamCreationWarningModal',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Требования для регистрации новой команды',
    },
    info: {
      type: Array,
      default: () => [],
    },
    showSubtext: {
      type: Boolean,
      default: false,
    },
    createLink: {
      type: String,
      default: '/team/create',
    },
    isMobileApp: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'create'],
};
</script>

<style lang="scss" scoped>
.team-creation-warning {
  .creation-warning__info {
    text-align: left;
  }

  .creation-warning__text {
    font-size: 16px;
    line-height: 24px;
    color: $color-black;

    ul {
      margin: 0;
      padding-left: 20px;
    }

    li {
      margin-bottom: 8px;
    }
  }

  .creation-warning__subtext {
    margin-top: 16px;
    font-size: 14px;
    line-height: 22px;
    color: $color-black-65;
  }

  .buttons-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;

    @media (min-width: breakpoint(md)) {
      flex-direction: row-reverse;
      gap: 16px;
    }

    &__item {
      flex: 1;

      &_first {
        order: -1;

        @media (min-width: breakpoint(md)) {
          order: 1;
        }
      }
    }
  }
}
</style>
